import * as commonFunctions from './common';
import * as coreFunctions from './coreApi';
import * as tokenFunctions from './tokens';

class API {
  constructor() {
    this.access_token = null;
    this.refresh_token = null;
    this.userId = '';
    this.headers = {
      'Content-Type': 'application/json'
    };
    this.tokenRefreshPromise = null;
    this.isImpersonating = false;
    this.originalToken = null;

    Object.assign(this, commonFunctions.default, coreFunctions.default, tokenFunctions.default);
  }
}

export default new API();
